import { UserInterest } from '@openclassrooms/sdk-web';
import { clientApi } from '../../configuration';
import getCRUDHooks from '../../utils/services/getCRUDHooks';

/* istanbul ignore next */
const { useUpdate: useUserInterestsUpdate, useGet: useUserInterests } = getCRUDHooks<
  UserInterest[]
>({
  entityName: 'userInterest',
  update: (
    userInterests: UserInterest[],
    {
      userId,
      queryParams,
      context,
    }: { userId: number; queryParams?: { step?: string }; context: any }
  ) =>
    clientApi
      .getOCClient()
      .helpers.user.users.addInterests(userId, userInterests, queryParams, context),
  get: (userId: number) => clientApi.getOCClient().helpers.user.users.getInterests(userId),
});

export { useUserInterestsUpdate, useUserInterests };
